import clsx from 'clsx';
import {useState} from 'react';

type Props = {
  /** Full URL to the image */
  src: string;
  alt: string;
  className?: string;
  title?: string;
  onLoad?: () => void;
  onError?: (error: Error) => void;
  loadingPlaceholder?: React.JSX.Element;
};

export function ProtectedImage({
  src,
  alt,
  className,
  title,
  onLoad,
  onError,
  loadingPlaceholder,
}: Props): React.JSX.Element | null {
  const [loaded, setLoaded] = useState(!loadingPlaceholder);

  return (
    <>
      {!loaded && loadingPlaceholder}
      <img
        src={src}
        alt={alt}
        title={title}
        className={clsx(className, 'text-transparent!')}
        hidden={!loaded && !!loadingPlaceholder}
        onLoad={() => {
          setLoaded(true);
          onLoad?.();
        }}
        onError={() => onError?.(new Error('Failed to load image'))}
      />
    </>
  );
}

ProtectedImage.displayName = 'ProtectedImage';
